export const environment = {
  production: true,
  CHECKIN_API_URL: '##{CHECKIN_BASE_API_URL}##',
  LOCALIZATION_API_URL: '##{LOCALIZATION_API_BASE_URL}##'
};